<template lang="pug">
  pagina
    breadcrumb(slot="breadcrumb", :itens="this.breadcrumb")
    album(slot="principal")
    sidebar(slot="lateral")
</template>

<script>
  import Album from 'MODULES/Album'
  import Breadcrumb from 'MODULES/Breadcrumb'
  import Pagina from 'MODULES/Pagina'
  import Sidebar from 'MODULES/Sidebar'

  export default {
    components: {
      Album,
      Breadcrumb,
      Pagina,
      Sidebar
    },
    data () {
      return {
        breadcrumb: [
          { nome: 'Galeria', rota: 'Galeria' }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Album.vue?107873f5